import { Http } from "@/util";

export function sendSimpleNotice(params) {
  return Http.post(`/admin/notice/send_simple_notice`, params);
}
